// Module
var code = `<div>
  <input
    type="text"
    placeholder="Lookup and add groups by name"
    ng-model="\$ctrl.name"
    ng-keydown="\$event.which === 13 && \$ctrl.search()"
    autocomplete="off"
    ng-disabled="\$ctrl.disabled"
  />
  <button class="btn btn-primary search-btn" type="button" ng-click="\$ctrl.search()"
          ng-disabled="!\$ctrl.enableSearch() || \$ctrl.disabled">
    Search
  </button>
  <button class="btn" type="button" ng-click="\$ctrl.clear()" ng-if="\$ctrl.visible">
    Clear
  </button>
</div>

<div class="content" ng-if="\$ctrl.visible">
  <div class="alert alert--danger" ng-if="\$ctrl.searchResults.length >= \$ctrl.resultLimit - 1">
    Too many results were returned. Only the first {{\$ctrl.resultLimit - 1}} are shown.
    Try making the query more specific.
  </div>

  <table ng-if="\$ctrl.searchResults.length > 0" class="table">
    <thead>
    <tr>
      <th>No.</th>
      <th>Group Name</th>
      <th>Group No.</th>
      <th>Branch</th>
      <th>Total members</th>
      <th>Center name</th>
      <th>Center reference no.</th>
      <th>Center status</th>
      <th>&nbsp;</th>
    </tr>
    </thead>

    <tbody>
    <tr ng-repeat="result in \$ctrl.searchResults">
      <td>{{\$index+1}}</td>
      <td>{{result.customerGroupName}}</td>
      <td>{{result.customerId}}</td>
      <td>{{\$ctrl.branchNames[result.customerBranchId]}}</td>
      <td>{{result.members.length}} members</td>
      <td>{{result.customerGroupCenter.name}}</td>
      <td>{{result.customerGroupCenter.id}}</td>
      <td>{{\$ctrl.getGroupCenterStatus(result.customerGroupCenter)}}</td>
      <td>
        <button
          type="button"
          ng-click="\$ctrl.onActionButtonClick(\$event, result)"
          class="btn btn-{{result.customerGroupCenter ? 'warning' : 'primary'}}"
        >
          {{result.customerGroupCenter ? 'Transfer here' : 'Add'}}
        </button>
      </td>
    </tr>
    </tbody>
  </table>

  <div class="no-results" ng-if="\$ctrl.searchResults.length === 0">
    No groups have been found.
  </div>

</div>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/customer/center/group-picker/group-picker.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;